import { Report197 } from "../../../components/borrowSystem/Report/Report197";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report197Container() {
  const titleName =
    "  สรุปข้อมูลสถานประกอบกิจะการที่กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน"; //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report197 />
      <Footer />
    </div>
  );
}
